import type { NDateLocale } from './enUS'
import { lt } from 'date-fns/locale'

const dateLtLT: NDateLocale = {
  name: 'lt-LT',
  locale: lt
}

export default dateLtLT
